import React, { useState, useRef } from 'react';
const tags = ['Interviews', 'Event', 'B2B', 'B2C', 'Retail', 'Iconic', 'OOH', 'TV', 'Marketer', 'Tech', 'Digital', 'Print', 'Social', 'Branding', 'Media', 'Strategy', 'Creative', 'Data', 'AI', 'Sustainability'];
export function TrendsTags() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const containerWidth = scrollRef.current.clientWidth;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -containerWidth * 0.6 : containerWidth * 0.6,
        behavior: 'smooth'
      });
    }
  };
  return <section className="site-container" style={{
    marginTop: '40px',
    marginBottom: '40px'
  }} data-id="element-310">
      <div className="flex items-center w-full h-[40px] lg:h-[56.25px]" style={{
      borderRadius: '18.75px',
      backgroundColor: '#000',
      overflow: 'hidden'
    }} data-id="element-311">
        {/* TRENDS label */}
        <div className="flex-shrink-0 flex items-center justify-center px-3 lg:px-5" data-id="element-312">
          <span className="text-[12px] lg:text-[18.75px]" style={{
          color: '#FFF',
          textAlign: 'center',
          fontFamily: 'Poppins, sans-serif',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: 'normal',
          letterSpacing: '1.875px',
          textTransform: 'uppercase' as const
        }} data-id="element-313">
            Trends
          </span>
        </div>

        {/* Scrollable tags */}
        <div ref={scrollRef} className="flex-1 flex items-center gap-1.5 lg:gap-2 overflow-x-auto no-scrollbar" style={{
        paddingRight: '8px'
      }} data-id="element-314">
          {tags.map((tag, idx) => <button key={idx} className="flex-shrink-0 cursor-pointer transition-colors duration-200 bg-white text-[#090909] hover:!bg-[#090909] hover:!text-white hover:!border-white h-[26px] lg:h-[37.5px] px-2.5 lg:px-4 text-[11px] lg:text-[18.75px]" style={{
          borderRadius: '18.75px',
          border: '1px solid #090909',
          textAlign: 'center',
          fontFamily: 'Poppins, sans-serif',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: 'normal',
          letterSpacing: '1px',
          textTransform: 'uppercase' as const
        }} data-id="element-315">
              {tag}
            </button>)}
        </div>

        {/* Arrow buttons */}
        <div className="flex-shrink-0 flex items-center justify-center h-full" style={{
        borderRadius: '0 18.75px 18.75px 0',
        border: '1px solid #090909',
        backgroundColor: '#FFF',
        paddingLeft: '12px',
        paddingRight: '12px',
        gap: '8px'
      }} data-id="element-316">
          <button onClick={() => scroll('left')} className="flex items-center justify-center cursor-pointer hover:opacity-70 transition-opacity" data-id="element-317">
            <span style={{
            color: '#000000'
          }} className="font-bold text-[22px] lg:text-[32px] leading-none" data-id="element-318">
              &lt;
            </span>
          </button>
          <button onClick={() => scroll('right')} className="flex items-center justify-center cursor-pointer hover:opacity-70 transition-opacity" data-id="element-319">
            <span style={{
            color: '#000000'
          }} className="font-bold text-[22px] lg:text-[32px] leading-none" data-id="element-320">
              &gt;
            </span>
          </button>
        </div>
      </div>
    </section>;
}